<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
            {{title}}
            </div>
        </div>
        <div class="m-panel-body" style="position: relative">
            <div style="height: 100%;height: 40%" class="water-pay-total">
                <!-- <Echart ref="option" :options="option" style="height: 100%"></Echart> -->
            </div>
            <div style="height: 100%;height: 50%">
                <!-- <Echart ref="option2" :options="option2" style="height: 100%"></Echart> -->
                <a-row style="padding: 20px">
                    <a-col :span="6" class="water-pay-total-type">
                        <p class="water-pay-total-type-title">{{ $t('昨日') }}</p>
                        <div class="ds-digital-bold water-pay-total-type-num">
                            <animated-integer :value="payMoneyCount.yesterdayPay"></animated-integer>
                            <span class="unit">{{ $t('元') }}</span>
                        </div>
                    </a-col>
                    <a-col :span="6" class="water-pay-total-type">
                        <p class="water-pay-total-type-title">{{ $t('今日') }}</p>
                        <div class="ds-digital-bold water-pay-total-type-num">
                            <animated-integer :value="payMoneyCount.curDayPay"></animated-integer>
                            <span class="unit">{{ $t('元') }}</span>
                        </div>
                    </a-col>
                    <a-col :span="6" class="water-pay-total-type">
                        <p class="water-pay-total-type-title">{{ $t('上月') }}</p>
                        <div class="ds-digital-bold water-pay-total-type-num">
                            <animated-integer :value="payMoneyCount.lastMonthPay"></animated-integer>
                            <span class="unit">{{ $t('元') }}</span>
                        </div>
                    </a-col>
                    <a-col :span="6" class="water-pay-total-type">
                        <p class="water-pay-total-type-title">{{ $t('本月') }}</p>
                        <div class="ds-digital-bold water-pay-total-type-num">
                            <animated-integer :value="payMoneyCount.curMonthPay"></animated-integer>
                            <span class="unit">{{ $t('元') }}</span>
                        </div>
                    </a-col>
                </a-row>
            </div>
            
        </div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import { postAction,putAction } from '@/api/manage';
import {isNull,isUndefined} from '@/utils/validate';
import animatedInteger from '@/components/maComponents/animated-integer';
export default {
    components:{
        animatedInteger
    },
    props: {
            titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            title: this.$t('营收分析'),
            option: {},
            option2: {},
            url: {
                payMoneyCount: '/jeecg-charge/meter/waterAnalysis/payMoneyCount'
            },
            payMoneyCount: {yesterdayPay: 0,curDayPay: 0,lastMonthPay: 0,curMonthPay: 0},
            curYearPay: 0
        }
    },
    mounted() {
        
    },
    computed: {
        curYearPayValue() {
            if(isNull(this.curYearPay)) {
                return this.$t('0元')
            }
            if(Number(this.curYearPay)>=10000) {
                return parseInt((Number(this.curYearPay)/10000)*10)/10+this.$t('万元')
            }else {
                return Number(this.curYearPay)+this.$t('元')
            }
        }
    },
    methods: {
        init() {
            this.$nextTick(()=> {
                //this.showOptionLoad()
                this.resetData()
                this.queryPayMoneyCount()
            })
        },
        showOptionLoad() {
            this.$refs.option.showLoading('default',{
                maskColor: 'rgba(0,0,0,0.3)',
                color: '#6ED9F2',
                text: ''
            })
            this.$refs.option2.showLoading('default',{
                maskColor: 'rgba(0,0,0,0.3)',
                color: '#6ED9F2',
                text: ''
            })
        },
        resetData() {
            this.option = this.$options.data.call(this).option
            this.option2 = this.$options.data.call(this).option2
        },
        queryPayMoneyCount() {
            putAction(this.url.payMoneyCount, {}).then((res) => {
                if(res.success){
                    this.payMoneyCount = res.result
                    this.curYearPay = res.result.curYearPay
                    //this.setOption()
                    //this.setOption2()
                }
            })
        },
        setOption() {
            let seriesData = []
            let data = [this.payMoneyCount.yesterdayPay,this.payMoneyCount.curDayPay]
            let category = [this.$t('昨日'),this.$t('今日')]
            for(let i = 0;i< data.length;i++) {
                seriesData.push({
                    name: category[i],
                    value: data[i]
                })
            }
            this.$refs.option.hideLoading()
            this.option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                    backgroundColor: 'rgba(0,11,42,0.9)',
                    borderColor: '#5D6A94',
                    borderWidth: 1,
                    borderRadius: 8,
                    textStyle: {
                        color: '#CEE2FF',
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            color: '#019AF3'
                        }
                    }
                },
                title: {
                    text: this.$t('日'),
                    textStyle: {
                        color: '#52C4DF',
                        fontSize: 24,
                        fontWeight: 500,
                    },
                    left: 'center',
                    top: 'center'
                },
                legend: {
                    orient: 'vertical',
                    bottom: 0,
                    data: category,
                    itemGap: 2,
                    icon: 'circle',
                    itemHeight: 10,
                    formatter: function(name) {
                        for(let i = 0;i<category.length;i++) {
                            if(category[i] == name) {
                                return '{normal|'+name+'} {ld|'+data[i]+'}'
                            }
                        }
                        return name
                    },
                    textStyle: {
                        rich: {
                            ld: {
                                fontFamily: 'ds-digital-bold',
                                fontSize: 18,
                                color: '#52C4DF'
                            },
                            normal: {
                                color: '#CEE2FF'
                            }
                        }
                    }
                },

                color: ["#0067FF", "#00CADF"],
                series: [{
                    name: this.$t('营收'),
                    type: 'pie',
                    radius: ['60%', '70%'],
                    avoidLabelOverlap: false,
                    startAngle:270,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: false,
                            fontSize: '30',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: seriesData,
                    roundCap: 1, //可选项为1和2，不填则采用原有拼接方式
                    animationDelay: 1000,
                    animationDuration: 2000,
                },
                {
                    name: '',
                    type: 'pie',
                    clockWise: false, //顺时加载
                    hoverAnimation: false, //鼠标移入变大
                    center: ['50%', '50%'],
                    radius: ['50%', '52%'],
                    tooltip: {
                        show: false
                    },
                    label: {
                        normal: {
                            show: false
                        }
                    },
                    itemStyle: {
                        color: '#50E3C2',
                        opacity: 0.4
                    },
                    data: [100]
                }
                ]
            };
        },
        setOption2() {
            let seriesData = []
            let data = [this.payMoneyCount.lastMonthPay,this.payMoneyCount.curMonthPay]
            let category = [this.$t('上月'),this.$t('本月')]
            for(let i = 0;i< data.length;i++) {
                seriesData.push({
                    name: category[i],
                    value: data[i]
                })
            }
            this.$refs.option2.hideLoading()
            this.option2 = {
                title: {
                    text: this.$t('月'),
                    textStyle: {
                        color: '#52C4DF',
                        fontSize: 24,
                        fontWeight: 500
                    },
                    left: 'center',
                    top: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                    backgroundColor: 'rgba(0,11,42,0.9)',
                    borderColor: '#5D6A94',
                    borderWidth: 1,
                    borderRadius: 8,
                    textStyle: {
                        color: '#CEE2FF',
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            color: '#019AF3'
                        }
                    }
                },
                legend: {
                    orient: 'vertical',
                    bottom: 0,
                    data: category,
                    itemGap: 1,
                    icon: 'circle',
                    itemHeight: 10,
                    formatter: function(name) {
                        for(let i = 0;i<category.length;i++) {
                            if(category[i] == name) {
                                return '{normal|'+name+'} {ld|'+data[i]+'}'
                            }
                        }
                        return name
                    },
                    textStyle: {
                        rich: {
                            ld: {
                                fontFamily: 'ds-digital-bold',
                                fontSize: 18,
                                color: '#52C4DF'
                            },
                            normal: {
                                color: '#CEE2FF'
                            }
                        }
                    }
                    
                },
                color: ["#7CC928", "#FECA20"],
                series: [{
                    name: this.$t('营收'),
                    type: 'pie',
                    radius: ['60%', '70%'],
                    center: ['50%', '50%'],
                    avoidLabelOverlap: false,
                    startAngle:270,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: false,
                            fontSize: '30',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    animationDelay: 1000,
                    animationDuration: 2000,
                    data: seriesData,
                    roundCap: 1 //可选项为1和2，不填则采用原有拼接方式
                },
                {
                    name: '',
                    type: 'pie',
                    clockWise: false, //顺时加载
                    hoverAnimation: false, //鼠标移入变大
                    center: ['50%', '50%'],
                    radius: ['50%', '52%'],
                    tooltip: {
                        show: false
                    },
                    label: {
                        normal: {
                            show: false
                        }
                    },
                    itemStyle: {
                        color: '#50E3C2'
                    },
                    data: [100]
                }
                ]
            };
        }
    }
}
</script>
<style scoped>
.water-pay-total {
    background: url('~@/assets/images/water-pay-total.png') no-repeat;
    background-size: 100% 100%;
    margin-top: 20px;
}
.water-pay-total-type{
    text-align: center;
    /* padding: 20px; */
}
.water-pay-total-type-title{
    font-size: 16px;
    color: #01B8FD;
}
.water-pay-total-type-num{
    font-size: 26px;
    color: #A8C6F3;
}
.water-pay-total-type-num .unit{
    color: #A8C6F3;
}
</style>